import TaxReportRepository from "@adapters/repositories/Reports/TaxReport";
import { accountDetails } from "@di";
export default (http) => {
    return {
        tax: new TaxReportRepository(http, accountDetails),
    };
};
